import ContractsScreen from './ContractsScreen';

export default ContractsScreen;
